import React from 'react';
import { Link } from 'react-router-dom';

export default function TestSEO() {
  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Test SEO Pages</h1>
      <p>Click on links below to test SEO pages:</p>
      
      <h2>Location Pages</h2>
      <ul>
        <li><Link to="/financial-advisor-toronto">Toronto</Link></li>
        <li><Link to="/financial-advisor-vancouver">Vancouver</Link></li>
        <li><Link to="/financial-advisor-montreal">Montreal</Link></li>
      </ul>
      
      <h2>Industry Pages</h2>
      <ul>
        <li><Link to="/medical-professionals-financial-advisor">Medical Professionals</Link></li>
        <li><Link to="/tech-entrepreneurs-financial-advisor">Tech Entrepreneurs</Link></li>
        <li><Link to="/small-business-owners-financial-advisor">Small Business Owners</Link></li>
      </ul>
      
      <h2>Combo Pages</h2>
      <ul>
        <li><Link to="/medical-professionals-toronto">Medical Professionals in Toronto</Link></li>
        <li><Link to="/real-estate-professionals-vancouver">Real Estate in Vancouver</Link></li>
      </ul>
      
      <h2>Index Pages</h2>
      <ul>
        <li><Link to="/locations">All Locations</Link></li>
        <li><Link to="/industries">All Industries</Link></li>
      </ul>
    </div>
  );
}